// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import LookupSiHaDocumentationStatusRequestModel from '../../model/lookup-si-ha-documentation-status-request-model';
import GetSiHaDocumentationStatusListRequestModel from '../../model/get-si-ha-documentation-status-list-request-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';
import SiHaDocumentationStatusListResultModel from '../../model/si-ha-documentation-status-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async lookupSiHaDocumentationStatus(request: LookupSiHaDocumentationStatusRequestModel, config?: RequestConfig) {
    const requestDTO = LookupSiHaDocumentationStatusRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-si-ha-documentation-status'] ?? 'siha/SiHaDocumentationStatus/Lookup';
    const response = await service.get<any>(endpointPath, {
      query: {
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async getSiHaDocumentationStatusList(request: GetSiHaDocumentationStatusListRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-si-ha-documentation-status-list'] ?? 'siha/SiHaDocumentationStatus';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SiHaDocumentationStatusListResultModel.toModel(dto));
  },
});
